export { Link } from './Link';
export type { Props as LinkProps } from './Link';
